import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BackButton, TableData } from "../../../../../components";
import { errorAlert } from "../../../../../helpers/alerts";
import { createCredTAEOperatorService, deleteCredTAEOperatorService } from "services/admin/providerService";
import { Grid } from "@mui/material";
import { getOperatorsService } from "services/admin/operatorServices";
import { setOperators as setCredTaeOperators } from "redux/slices/admin/providerSlice";
import { setOperators } from "redux/slices/admin/operatorSlice";

const CredTAEOperatorsScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    providerCredSelected,
    operators: credTaeOperators,
  } = useSelector((store) => store.providers);
  const { operators } = useSelector((store) => store.operators);


  useEffect(() => {
    getOperatorsService()
      .then((data) => dispatch(setOperators(data)))
      .catch(error => errorAlert(error))
    // eslint-disable-next-line
  }, []);

  const handlerCheck = async ({ id }, currentValue) => {
    (currentValue ?
      deleteCredTAEOperatorService(providerCredSelected.id, id) :
      createCredTAEOperatorService(providerCredSelected.id, id)
    ).then((result) => {
      dispatch(setCredTaeOperators(result));
    }).catch(error => errorAlert(error))
  };

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <div>
          <BackButton click={() => navigate('..')} />
        </div>
        <div className="container-title">
          <div className="title">Productos - Operadoras</div>
          <div className="subtitle">{providerCredSelected.name_connector}</div>
        </div>
        <div style={{ width: "170px" }}></div>
      </Grid>
      <TableData
        dataRows={operators.map((item) => {
          const find = credTaeOperators.find(({ idOperator }) => idOperator.id === item.id);
          return { ...item, state: find ? true : false };
        })}
        dataTitle={["Logo", "Nombre", "Estado"]}
        formatter={({ name, state, fd }) => [
          { type: "img", value: `/v3/file/${fd}/` },
          name,
          { name: "state", type: "boolean", value: state },
        ]}
        onChecked={handlerCheck}
      />
    </>
  );
};

export default CredTAEOperatorsScreen;
